import React, { ReactElement } from "react";
import { Checkbox } from "@components/form";
import clsx from "clsx";

interface IProps {
  onChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => void;
  companySpecializationsList: number[];
  networkingProfileSpecializations: number[];
  editMode: boolean;
  hasError?: boolean;
}

const Specialization = ({
  companySpecializationsList,
  networkingProfileSpecializations,
  onChange,
  editMode,
  hasError = false,
}: IProps): ReactElement => {
  return (
    <div className="profile-netw-step">
      <div
        className={clsx("profile-netw-step__body", {
          "profile-netw-step--error": editMode && hasError,
        })}
      >
        <div className="profile-netw-step__body-header">
          <p className="profile-netw-step__title">
            <span>Для сотрудников турагентств и туроператоров:</span> На каких
            видах туризма вы специализируетесь?
          </p>
          <p className="profile-netw-step__desc">
            Отметьте один или несколько пунктов, если данные виды туризма
            занимают существенную долю в ваших продажах.
          </p>
        </div>

        {editMode ? (
          <div className="profile-netw-step__main profile-netw-step__main--checkbox-list">
            {companySpecializationsList?.map((Item: any, index: number) => (
              <Checkbox
                key={index}
                name="languages"
                type="profile"
                placeholder={Item.name}
                value={Item.id}
                hiddenInput
                checked={networkingProfileSpecializations?.includes(Item.id)}
                onChange={onChange}
              />
            ))}
          </div>
        ) : (
          networkingProfileSpecializations?.length > 0 &&
          companySpecializationsList?.some((Item: any) =>
            networkingProfileSpecializations.includes(Item.id)
          ) && (
            <div className="profile-netw-step__main profile-netw-step__main--item-list">
              {companySpecializationsList.map(
                (Item: any, index: number) =>
                  networkingProfileSpecializations.includes(Item.id) && (
                    <div key={index} className="profile-netw-step__main-item">
                      {Item.name}
                    </div>
                  )
              )}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Specialization;
